var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1001 0C16.8988 0 21.6 4.70127 21.6 10.5C21.6 16.2987 16.8986 21 11.1001 21C5.30156 21 0.600098 16.3 0.600098 10.5C0.600098 4.70001 5.30072 0 11.1001 0Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3959 9.10207V7.54009H15.9677V5.16016H6.24142V7.54009H9.81372V9.10081C6.91048 9.23416 4.72754 9.80914 4.72754 10.4979C4.72754 11.1867 6.91153 11.7617 9.81372 11.8959V16.8992H12.3967V11.8955C15.2947 11.7617 17.4732 11.1872 17.4732 10.499C17.4732 9.81082 15.2947 9.23626 12.3967 9.10249L12.3959 9.10207ZM12.3967 11.4717V11.4704C12.3238 11.4751 11.9494 11.4975 11.1157 11.4975C10.4492 11.4975 9.98025 11.4786 9.81498 11.47V11.4721C7.25005 11.3585 5.33549 10.9118 5.33549 10.3774C5.33549 9.84295 7.25026 9.39691 9.81498 9.28309V11.0271C9.98298 11.0387 10.4635 11.067 11.1266 11.067C11.9232 11.067 12.3236 11.0339 12.3971 11.0271V9.28309C14.957 9.39712 16.8672 9.84421 16.8672 10.3768C16.8672 10.9093 14.9562 11.3566 12.3971 11.4707",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.181bb3f5bf87bfabb45d85e37bdbc448.svg";
export { ForwardRef as ReactComponent };